import { Box, Button, Flex, SimpleGrid, type SimpleGridProps } from '@chakra-ui/react'

import type { BlogArticleDetails, BlogArticlePinnedTo } from '@/client/services/blog'

import Pagination from '@/components/Pagination/Pagination'

import BlogArticleCard from './BlogArticleCard'

export default function BlogArticleList({
  blogArticles,
  columns = [1, 2, 3],
  pinnedToContext,
  infiniteScrollConfig,
  paginationConfig,
}: {
  blogArticles: BlogArticleDetails[]
  columns?: SimpleGridProps['columns']
  pinnedToContext?: BlogArticlePinnedTo
  infiniteScrollConfig?: {
    queryLimit: number
    handleLoadMore: () => void
    countTotalItems: number
  }
  paginationConfig?: {
    offset: number
    countTotalItems: number
    pageSize: number
  }
}): React.ReactElement {
  return (
    <>
      <SimpleGrid columns={columns} spacing="16px" gridAutoRows="min-content">
        {blogArticles.map(blogArticle => (
          <BlogArticleCard
            key={blogArticle.id}
            blogArticle={blogArticle}
            pinnedToContext={pinnedToContext}
          />
        ))}
      </SimpleGrid>
      {infiniteScrollConfig != null &&
      infiniteScrollConfig.countTotalItems > infiniteScrollConfig.queryLimit ? (
        <Flex justifyContent="center" my="24px">
          <Button variant="outline" minWidth="150px" onClick={infiniteScrollConfig.handleLoadMore}>
            See More
          </Button>
        </Flex>
      ) : (
        <Box mb="48px" />
      )}
      {paginationConfig != null ? (
        <Pagination
          scheme="url"
          itemsPerPage={paginationConfig.pageSize}
          totalItemsCount={paginationConfig.countTotalItems}
        />
      ) : null}
    </>
  )
}
